import {useEffect, useRef} from "react";

import isEqual from "lodash.isequal";

export const useDeepCompareEffect = (callback, dependencies) => {
  const currentDependenciesRef = useRef();

  // Глубоко сравниваем текущие зависимости с предыдущими
  if (!isEqual(currentDependenciesRef.current, dependencies)) {
    // Если они не равны, обновляем ссылку
    currentDependenciesRef.current = dependencies;
  }

  // useEffect теперь зависит от ссылки, которая меняется только
  // после успешного глубокого сравнения.
  useEffect(callback, [currentDependenciesRef.current]);
};
